import { render, staticRenderFns } from "./TemplateDesign.vue?vue&type=template&id=6f47c6be"
import script from "./TemplateDesign.vue?vue&type=script&lang=js"
export * from "./TemplateDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports